import { AuthContext } from 'context/AuthContext';
import { useContext } from 'react';
import { useMutation } from 'react-query';
import { publicFetch, delay } from 'utilities/fetch';

function useAdminLogin() {
  const authContext = useContext(AuthContext);

  async function adminLogin(data) {
    const response = await publicFetch.post(`/v1/admin/login`, data).then((res) => res.data);
    authContext.updateState({ delayBeforeLoginSuccess: true });
    await delay(1500);
    return response;
  }

  return useMutation(adminLogin, {
    onSuccess(data) {
      const { accessToken: token, refreshToken } = data?.data || {};
      authContext.setTokens({ token, refreshToken });
    },
    onError() {},
  });
}

export default useAdminLogin;
